// extracted by mini-css-extract-plugin
export default {"salesOptionsContainer":"BrandInformation_salesOptionsContainer__MWmok"};